<template>
    <div v-bind:style="{ 'margin-bottom': value }"></div>
</template>

<script>
  export default {
    name: "spacing",
    props: ['value']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/blocks/Spacing.vue